<div class="schedule-view-container">
	<div class="heading">
		<app-page-subtitle title="Schedule View"></app-page-subtitle>
	</div>

	<div class="content">
		<app-step-navigator
			[stepConfig]="navigationConfig"
			[(selectedStep)]="selectedStep"
			(selectedStepChange)="selectedStepChange.emit($event)"
		></app-step-navigator>

		<app-loading-state [isLoading]="isLoading" [loadedContent]="scheduleTable"></app-loading-state>
		<ng-template #scheduleTable>
			<div class="table-container">
				<ng-container *ngIf="assessments.length; else noAssessments">
					<ng-container *ngFor="let assessment of assessments">
						<app-schedule-card [assessment]="assessment"></app-schedule-card>
					</ng-container>
				</ng-container>
				<ng-template #noAssessments>
					<em>No assessments available.</em>
				</ng-template>
			</div>
		</ng-template>
	</div>
</div>
